const client_id =
  "95958156867-hrencuvkclu370jbbj84eshlhefg1u8i.apps.googleusercontent.com";

const redirect_uri = `${process.env.VUE_APP_DASHBOARD_API_URL}Onboarding/oauth/`;

export const generateGoogleLink = (email) =>
  `https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/adwords&access_type=offline&%20include_granted_scopes=true&state=email:${email}&redirect_uri=${redirect_uri}&response_type=code&client_id=${client_id}`;
